import React from "react";
import styles from "./FixedWeb.module.css";
import whatsapp from "../../asset/fixed/whatsappIcon.webp";
import { useDetectScrollStop } from "../../hooks/useDetectScrollStop";
import { useContactDetails } from "../../contexts/contact-context";

const FixedWeb = () => {
  const { userHasScrolled } = useDetectScrollStop();
  const { whatsappNumber, whatsappText } = useContactDetails();

  return (
    <div
      className={`${styles.fixed} && ${userHasScrolled && styles.round} `}
      onClick={() =>
        window.open(`https://wa.me/${whatsappNumber}?text=${whatsappText}`)
      }
    >
      <img src={whatsapp} alt="whatsapp" />
      <div className={styles.text}>
        <div
          className={styles.h5}
          style={{
            display: userHasScrolled ? "none" : "block",
          }}
        >
          Chat with us on whatsapp
        </div>
        <div
          className={styles.h6}
          style={{
            display: userHasScrolled ? "none" : "block",
          }}
        >
          For product related informations
        </div>
      </div>
    </div>
  );
};

export default FixedWeb;
